jQuery(function($){
	$('.hide').removeClass('.hide').hide();

	// ERASE TEXT IN SEARCH FIELD
	var GB = {
		text_labels: function () {
			$('input[type=text], textarea').each(function () {
				var $input = $(this);
				if (!$input.attr('placeholder'))
					$input.attr('placeholder', $input.val());
				$input.focus(function () {
					if (this.value == $input.attr('placeholder')) this.value = '';
					$input.addClass('focus');
				});
				$input.blur(function () {
					if (this.value == '') this.value = $input.attr('placeholder');
					$input.removeClass('focus');
				});
			});
		},
		close_overlay: function () {
			$('#contactOverlay, #overlay_container, #overlay').remove();
			return false;
		},
	};

	// INIT GLOBAL SEARCH
	$('.search-query').submit(function () {
		var $field = $(this).find('input[name="query"]').eq(0);
		var val = $field.val();
		if (val != '' && val != $field.attr('placeholder')) {
			///if not on search results page, update form action
			///else go to search results page
			if ($('.global-search').index() == -1) {
				var url = $(this).attr('action');

				if (url.indexOf('#') > -1) url = url.strstr(0, url.indexOf('#'));

				url += '#/?query=' + val;

				$(this).attr('action', url);
			} else {
				$('#searchForm input[name="query"]').val(val).change();
				return false;
			}
		} else {
			return false;
		}
	});

	// GB.text_labels();

	// HEADER SITE SEARCH TOGGLE
	$('#headerNav ul li.search a.searchToggle').click(function (event) {
		event.preventDefault(); //stop browser from loading anchor link
		$(this).hide();
		$('#siteSearchForm').show();
		$('#siteSearchForm input.siteSearchInput').animate(
			{ width: 'toggle' },
			500
		);
		$('#siteSearchForm input.siteSearchInput').focus();
	});

});


// Custom.js
(function ($) {
	// On Dom Ready
	$(function () {
		// add scriptes here
		$('.menu-open').click(function (e) {
			e.preventDefault();
			$(this).toggleClass('is-active');
			$('.mobile-menu-wrapper').toggleClass('active');
		});

		// dropdown button functionality
		$('.hero-dropdown-button').on('click', function (event) {			
			if( $(this).hasClass('open') ){
				console.log('hide all');
				$('.hero-dropdown-button').removeClass('open');
				$('.hero-dropdown-wrap .links').stop().slideUp(); // hide ALL dropdowns
			} else {
				console.log('show all');
				$('.hero-dropdown-button').addClass('open');
				$('.hero-dropdown-wrap .links').stop().slideDown();	// show ALL dropdowns
			}
		});
		$(document).on('click', function(event){
			if(!$(event.target).closest('.hero-dropdown-wrap').length){
				$('.hero-dropdown-button').removeClass('open');
				$('.hero-dropdown-wrap .links').stop().slideUp();	// hide ALL dropdowns
			}
		});

		$('.searchToggle').click(function (e) {
			e.preventDefault();
			$('#siteSearchForm2').show();
			$('#siteSearchForm2 input.siteSearchInput').animate(
				{
					width: 'toggle',
				},
				500
			);
			$('#siteSearchForm2 input.siteSearchInput').focus();
		});

		// .hero-carousel .the-carousel Carousel
		$('.hero-carousel .the-carousel').slick({
			autoplay: true,
			autoplaySpeed: 10000,
			dots: true,
			arrows: false,
			infinite: true,
			speed: 700,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			rows: 0,
			fade: true,
			pauseOnHover: false,
			pauseOnFocus: false,
		});
		
		$('.hero-carousel .slick-pause').on('click', function(e){
			e.preventDefault();
			if($(this).hasClass('paused')) {
				$(this).removeClass('paused');
				$('.hero-carousel .the-carousel').slick('slickPlay');
			} else {
				$(this).addClass('paused');
				$('.hero-carousel .the-carousel').slick('slickPause');
			}
		});

		// .home-find-attorney .the-attorney .the-carousel Carousel
		$('.home-find-attorney .the-attorney .the-carousel').randomize().slick({
			autoplay: true,
			autoplaySpeed: 6000,
			dots: false,
			arrows: false,
			infinite: true,
			speed: 700,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			rows: 0,
			fade: true,
			pauseOnHover: false,
			pauseOnFocus: false,
		});

		// .home-upcoming-events .the-content .the-carousel Carousel
		$('.home-upcoming-events .content-col .the-carousel').slick({
			autoplay: true,
			autoplaySpeed: 3000,
			dots: false,
			arrows: true,
			infinite: true,
			speed: 700,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			rows: 0,
			fade: true,
		});

		// scroll to bottom
		$('.scroll-down').click(function (e) {
			e.preventDefault();
			var anchor_id = '#mainContent';
			$('html,body').animate({ scrollTop: $(anchor_id).offset().top }, 'slow');
		});
	});

	// After page loaded completely
	$(window).on('load', function () {});

	// Randomize Slick carousel
	$.fn.randomize = function (selector) {
		var $elems = selector ? $(this).find(selector) : $(this).children(),
			$parents = $elems.parent();

		$parents.each(function () {
			$(this)
				.children(selector)
				.sort(
					function (childA, childB) {
						// * Prevent last slide from being reordered
						if ($(childB).index() !== $(this).children(selector).length - 1) {
							return Math.round(Math.random()) - 0.5;
						}
					}.bind(this)
				)
				.detach()
				.appendTo(this);
		});

		return this;
	};
})(jQuery);

// Get URL parameter
// https://stackoverflow.com/a/21903119/5277665
var getUrlParameter = function getUrlParameter(sParam) {
	var sPageURL = window.location.search.substring(1),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam) {
			return typeof sParameterName[1] === undefined
				? true
				: decodeURIComponent(sParameterName[1]);
		}
	}
	return false;
};



// New Version
jQuery(function($){
	
	// .home-upcoming-events .the-content .the-carousel Carousel
	$('.testimonial-slider').each(function(){
		let theSlider = $(this);
		theSlider.slick({
			autoplay: true,
			autoplaySpeed: 5000,
			dots: true,
			arrows: false,
			infinite: true,
			speed: 700,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			rows: 0,
			fade: true,
		});
		
		theSlider.next('.slick-pause').on('click', function(e){
			e.preventDefault();
			if($(this).hasClass('paused')) {
				$(this).removeClass('paused');
				theSlider.slick('slickPlay');
			} else {
				$(this).addClass('paused');
				theSlider.slick('slickPause');
			}
		});
		
	});
		
	
	
	$('.hero-tabs a').on('click', function(e){
		e.preventDefault();
		if(!$(this).hasClass('active')) {
			let target = $(this).attr('href');
			$('.tab-content').hide();
			$(target).fadeIn(200);
			$('.hero-tabs a').removeClass('active');
			$(this).addClass('active');
		}
	});	
	
	$('.hero-form-toggle').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('active');
		$('.form-toggle-content').slideToggle(300);
	});
	
	$('.accordion-widget .accordion-toggle-btn').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).closest('.button-wrap').next().slideToggle(300);
	});
	
	$('.more-related-items-btn').on('click', function(e){
		e.preventDefault();
		let showNum = $(this).data('show');
		let holder = $(this).closest('.more-btn-wrap').siblings('.listing-js');
		let hiddenEl = holder.find('>:hidden').slice(0, showNum);
		hiddenEl.addClass('show');
		if(!holder.find('>:hidden').length) {
			$(this).closest('.more-btn-wrap').remove();
		}
	});
	
	// Mobile Tabbed Content
	$('.mobile-tab-button').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('active');
		$($(this).data('target')).slideToggle(300);
	});
	
	$('.mobile-toggle-sub-item').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).next().toggleClass('active');
	});
	
	// More content
	$('.show-more-content-btn-wrap button').on('click', function(e){
		e.preventDefault();
		let thisWrapper = $(this).closest('.show-more-content-btn-wrap');
		thisWrapper.siblings('.hidden-content').removeClass('hidden-content');
		thisWrapper.remove();
	});
	
	// Ajax
	$('#siteContainer').on('click', '.ajax-btn-wrap a', function(e){
		e.preventDefault();
		let btnWrap = $(this).closest('.ajax-btn-wrap');
		let target = $(this).attr('href');
		let holderSelector = btnWrap.data('holder');
		btnWrap.addClass('loading-ajax');
		
		$.get(target, (response) => {
			$(holderSelector).append($(response).find(holderSelector).html());
			convertImages('img.svg-inline');			
			btnWrap.remove();
			let responseBtn = $(response).find('.ajax-btn-wrap[data-holder="' + holderSelector + '"]');
			if(responseBtn.length) {
				responseBtn.insertAfter(holderSelector);
			}
		});
		
	});
	
	
	const convertImages = (query, callback) => {
	  const images = document.querySelectorAll(query);
	  images.forEach(image => {
		 
		fetch(image.src)
		.then(res => res.text())
		.then(data => {
		  const parser = new DOMParser();
		  const svg = parser.parseFromString(data, 'image/svg+xml').querySelector('svg');

		  if (image.id) svg.id = image.id;
		  if (image.className) svg.classList = image.classList;

		  image.parentNode.replaceChild(svg, image);
		})
		.then(callback)
		.catch(error => console.error(error))
	  });
	}
	convertImages('img.svg-inline');
	
	
	// Mobile Nav: Sub menu
	$('.mobile-menu-wrapper li.menu-item-has-children').each(function(){
		//$(this).append('<button type="button" class="submenu-toggle"><span class="screen-reader-text">Show/Hide Sub Menu</span></button>');
		$('<button type="button" class="submenu-toggle"><span class="screen-reader-text">Show/Hide Sub Menu</span></button>').insertAfter($('>a', this));
	});
	$('.mobile-menu-wrapper').on('click', '.submenu-toggle', function(){
		$(this).toggleClass('expanded');
		$(this).siblings('ul').slideToggle(200);
	});

});